export const RouteModel = {
    id: "",
    name: "",
    prog_name: "",
    prog_id: "",
    route_id: "",
    created_at: null,
    download_type: "",
    waste_type: "",
    type: "",
    geojson: {},
    checkpoints: [],
    hour_start: null,
    hour_end: null,
    driver: null,
    truck: null,
    available_drivers: [],
    available_trucks: [],
    requires: {},
    opened_at: null,
    unload_status: null,
    can_delete: false,
}

// estados de la sesión de cabina (RouteUnload.status) que dejan la ruta en solo lectura: en curso, hecha
export const RouteReadOnlyStatus = ["I", "D"];
